import { ChakraProvider } from "@chakra-ui/react";
import { ThemeProvider } from "next-themes";

import { system, systemPrimary, systemSecondary, systemSenior } from "../theme";
import "../assets/fonts.css";

interface PropTypes {
  children: React.ReactNode;
  gradeTheme?: GradeTheme;
  forcedTheme?: "light" | "dark";
}

export enum GradeTheme {
  Primary = "PRIMARY",
  Secondary = "SECONDARY",
  Senior = "SENIOR"
}

const EukaBarkProvider = ({ children, gradeTheme, forcedTheme }: PropTypes) => {
  const getGradeTheme = () => {
    switch (gradeTheme) {
      case GradeTheme.Primary:
        return systemPrimary;
      case GradeTheme.Secondary:
        return systemSecondary;
      case GradeTheme.Senior:
        return systemSenior;
      default:
        return system;
    }
  };

  return (
    <ChakraProvider value={getGradeTheme()}>
      <ThemeProvider
        attribute="class"
        disableTransitionOnChange
        enableSystem
        forcedTheme={forcedTheme}
      >
        {children}
      </ThemeProvider>
    </ChakraProvider>
  );
};

export default EukaBarkProvider;
